import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * The one neutral-slate banner used everywhere a warning/info note appears
 * in this redesign (alert stack, spec-issue note, feature-duplication note,
 * market-undercut note, variant MPN/UPC warning). Deliberately colorless —
 * a warning glyph or a small colored dot carries the signal, never a tinted
 * background (the design chat explicitly walked back amber-tinted panels).
 */
export function NeutralNote({ children, icon }: { children: React.ReactNode; icon?: React.ReactNode }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 1.25,
        p: '11px 13px',
        borderRadius: '10px',
        bgcolor: (theme) => theme.palette.grey[50],
        border: '1px solid',
        borderColor: (theme) => theme.palette.grey[200],
      }}
    >
      {icon}
      <Typography variant="body2" sx={{ fontSize: '12.5px', lineHeight: 1.55, color: 'text.secondary' }}>
        {children}
      </Typography>
    </Box>
  );
}
